import React from 'react';
import '../css/GlobalStickyHub.css';

const GlobalStickyHub = () => {
  // Configured default corporate urls tracking for your system branding assets
  const socialLinks = {
    linkedin: "https://linkedin.com/company/jivusphere",
    youtube: " https://youtube.com/@greenfieldsafetyhub?si=ryA-EwIJ8FFATyxG",
    facebook: "https://www.facebook.com/profile.php?id=100089558869270",
    instagram: "https://www.instagram.com/gifsa_gkp?igsh=ZncwbmhvZGE4bmtl",
    whatsapp: "https://wa.me/91XXXXXXXXXX?text=Hi!%20I%20am%20interested%20in%20Fire%20and%20Safety%20Courses.",
    phone: "tel:+91XXXXXXXXXX"
  };

  return (
    <div className="gfi-global-sticky-hub">
      
      {/* 1. RIGHT-SIDE CENTER: SYSTEM SOCIAL LINKS WHEEL */}
      <nav className="gfi-sticky-social-rail" aria-label="Social Media Direct Links">
        <a href={socialLinks.linkedin} target="_blank" rel="noreferrer" className="gfi-rail-item linkedin" title="LinkedIn Business Profile">
          <span className="gfi-icon-vector">in</span>
        </a>
        <a href={socialLinks.youtube} target="_blank" rel="noreferrer" className="gfi-rail-item youtube" title="YouTube Official Channel">
          <span className="gfi-icon-vector">▶</span>
        </a>
        <a href={socialLinks.facebook} target="_blank" rel="noreferrer" className="gfi-rail-item facebook" title="Facebook Connect">
          <span className="gfi-icon-vector">f</span>
        </a>
        <a href={socialLinks.instagram} target="_blank" rel="noreferrer" className="gfi-rail-item instagram" title="Instagram Feed">
          <span className="gfi-icon-vector">📸</span>
        </a>
      </nav>

      {/* 2. RIGHT-SIDE BOTTOM: CORE ACTION UTILITY PILLS */}
      <div className="gfi-sticky-action-triggers">
        {/* Phone Contact Action Circle */}
        <a href={socialLinks.phone} className="gfi-action-circle phone-trigger" title="Call Career Helpline Team">
          <span className="gfi-trigger-icon">📞</span>
        </a>

        {/* WhatsApp Rapid Chat Anchor */}
        <a href={socialLinks.whatsapp} target="_blank" rel="noreferrer" className="gfi-action-circle whatsapp-trigger" title="Chat on WhatsApp Support">
          <span className="gfi-trigger-icon">💬</span>
          <span className="gfi-pulse-halo"></span>
        </a>
      </div>

    </div>
  );
};

export default GlobalStickyHub;